import { ref, computed, watch } from "@vue/composition-api";
import { useToast } from "vue-toastification/composition";
import { debounce } from "lodash";
import moment from "moment-timezone";
import store from "@/store";
import ability from "@/libs/acl/ability";
import useFilterCounter from "@/components/Filters/useFiltersCount";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default function useList(showFilters = true) {
  const refListTable = ref(null);
  const toast = useToast();

  store.dispatch("unit/getAll", { is_main_unit: 1 });
  const unitOptions = computed(() => store.getters["unit/getSelectedItems"]);
  const unitFilter = ref(null);

  const tableColumns = [
    { label: "pisos.unit_id", key: "unit.description", sortable: true },
    { label: "pisos.active_inactive", key: "unit.active", sortable: true },
    { label: "pisos.rems", key: "unit.rems", sortable: true },
    { label: "pisos.sirh", key: "unit.sirh", sortable: true },
    { label: "pisos.sector", key: "unit.sector.name", sortable: true },
    { label: "pisos.floor_number", key: "floor_number", sortable: true },
    { label: "pisos.headcount_table", key: "headcount", sortable: true },
    /* {
      label: "date.created_at",
      key: "created_at",
      sortable: true,
      formatter: "formatDateAssigned",
    },
    {
      label: "date.updated_at",
      key: "updated_at",
      sortable: true,
      formatter: "formatDateAssigned",
    }, */
  ];

  if (
    showFilters &&
    (ability.can("update", "UnitFloor") || ability.can("delete", "UnitFloor"))
  ) {
    tableColumns.splice(0, 0, { label: "actions.name", key: "actions" });
  }

  const perPage = ref(10);
  const totalList = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);
  const action = ref("list");

  const dataMeta = computed(() => {
    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalList.value,
    };
  });

  const fetchList = (ctx, callback) => {
    store
      .dispatch("pisos/getAll", {
        q: searchQuery.value,
        max: perPage.value,
        "page[n]": currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        action: action.value,
        units: unitFilter.value,
      })
      .then((response) => {
        if (action.value == "export") {
          action.value = "list";
        } else {
          callback(response.data);
          totalList.value = response.meta.total;
        }
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: "Error obteniendo la información",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  const formatDateAssigned = (value) => {
    const formattedDate = moment(value).format("DD/MM/YYYY HH:mm:ss");
    return formattedDate;
  };

  const refetchData = () => {
    refListTable.value.refresh();
  };

  watch([currentPage, perPage], () => {
    refetchData();
  });

  watch(
    [searchQuery],
    debounce(() => {
      refetchData();
    }, 500)
  );

  const filters = ref({});
  const filtersCount = useFilterCounter(filters);
  const buildFilters = () => {
    filters.value = {
      unit: unitFilter.value,
    };
    refetchData();
  };
  const clearSearchFilters = () => {
    unitFilter.value = null;
    buildFilters();
  };

  return {
    tableColumns,
    perPage,
    currentPage,
    totalList,
    fetchList,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refListTable,
    formatDateAssigned,
    refetchData,
    action,
    unitOptions,
    unitFilter,
    filtersCount,
    buildFilters,
    clearSearchFilters,
  };
}

